import { Box, Checkbox, Typography } from "@mui/material";

const columns = [
  { key: "name", label: "Insumo", flex: 1.8 },
  { key: "category", label: "Categoría", flex: 1.25 },
  { key: "baseUnit", label: "Unidad de medida", flex: 1.2 },
  { key: "defaultYieldFactor", label: "Rendimiento base", flex: 0.9 },
  { key: "isActive", label: "Activo", flex: 0.75 },
];

const tableGridTemplate = columns.map((column) => `${column.flex}fr`).join(" ");

function TextCell({ children }) {
  return (
    <Typography
      sx={{
        color: "primary.900",
        fontSize: 14,
        fontWeight: 600,
        textAlign: "center",
      }}
    >
      {children}
    </Typography>
  );
}

export default function AddInsumosTable({
  rows = [],
  selectedIds = [],
  loading = false,
  onToggleRow,
  height = 420,
}) {
  return (
    <Box sx={{ borderRadius: "20px", overflow: "hidden" }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: tableGridTemplate,
          columnGap: 1,
          alignItems: "center",
          bgcolor: "neutral.600",
          px: 2,
          py: 1.2,
        }}
      >
        {columns.map((column) => (
          <Typography
            key={column.key}
            sx={{
              fontSize: 14,
              fontWeight: 700,
              color: "logoblanco",
              textAlign: "center",
            }}
          >
            {column.label}
          </Typography>
        ))}
      </Box>

      <Box sx={{ bgcolor: "neutral.50", height, overflowY: "auto" }}>
        {rows.map((ingredient) => {
          const ingredientId = String(ingredient.catalogId ?? ingredient.id);
          const checked = selectedIds.includes(ingredientId);

          return (
            <Box
              key={ingredientId}
              sx={{
                px: 2,
                py: 1.2,
                borderBottom: "1px solid rgba(0,0,0,.06)",
                bgcolor: checked ? "secondary.50" : "transparent",
                cursor: loading ? "default" : "pointer",
                "&:hover": { bgcolor: checked ? "secondary.50" : "rgba(0,0,0,.03)" },
              }}
              onClick={() => {
                if (!loading) onToggleRow?.(ingredientId);
              }}
            >
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: tableGridTemplate,
                  columnGap: 1,
                  alignItems: "center",
                }}
              >
                <TextCell>{ingredient.name}</TextCell>
                <TextCell>{ingredient.category}</TextCell>
                <TextCell>{ingredient.baseUnitLabel}</TextCell>
                <TextCell>{ingredient.yieldLabel}</TextCell>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Checkbox
                    checked={checked}
                    disabled={loading}
                    onClick={(event) => event.stopPropagation()}
                    onChange={() => onToggleRow?.(ingredientId)}
                    sx={{
                      color: "secondary.500",
                      "&.Mui-checked": { color: "secondary.500" },
                    }}
                  />
                </Box>
              </Box>
            </Box>
          );
        })}

        {rows.length === 0 && (
          <Box sx={{ p: 3 }}>
            <Typography sx={{ color: "neutral.700", fontWeight: 600 }}>
              {loading
                ? "Cargando insumos disponibles…"
                : "No hay insumos disponibles para agregar."}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
